import { atom } from 'jotai';

export const envBannerBorderEnabledAtom = atom(true);
envBannerBorderEnabledAtom.debugLabel = 'envBannerBorderEnabled';

export const envBannerBorderSetEnabledAtom = atom(null, (_get, set, nextEnabled: boolean) => {
  set(envBannerBorderEnabledAtom, nextEnabled);
});
envBannerBorderSetEnabledAtom.debugLabel = 'envBannerBorderSetEnabled';
